export const historyQuestionnaire = {
  insuranceClaim: 'qp/76',
  insuranceClaimValue: 'qp/76/amount',
  cleanHistoryReport: 'qp/124',
  odors: 'qp/65',
  titleFreeAndClear: 'qp/82',
  originalOwner: 'qp/83',
  auctionedRecently: 'qp/81',
  hasBothKeys: 'qp/79',
  rentalCar: 'qp/125',
  serviceRecords: 'qp/17',
  completeRoadsideKit: 'qp/141',
  hasVehicleDamage: 'qp/142',
  hadPreviousPaintWork: 'qp/143'
}

export const vehicleIssuesAnswer = {
  Yes: 0,
  No: 1,
  'Not Sure': 2
}
